import React from "react";

const AuthContainer = ({ isSignIn, children }) => {
  return (
    <div className="containerPageConnexion">
      <div className={`containerConnexion ${isSignIn ? "active" : ""}`} id="container">
        {children}
      </div>
    </div>
  );
};

export default AuthContainer;
